import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, Spinner } from 'react-bootstrap';
import useAppChoices from '../../../hooks/useAppChoices';

const ETARequiredModal = ({ show, onHide, showProgress, onSubmit, orderType, pendingStatus, initialValues = {} }) => {
  const [formData, setFormData] = useState({
    estimatedTurnAroundTime: '',
    etaReason: '',
    assignedSurveyor: '',
    hardCost: '',
    processingFee: ''
  });

  const isSurveyOrder = orderType === 'Survey';
  const showSurveyOrderFields = isSurveyOrder && pendingStatus === 'Information Requested';
  const surveyors = useAppChoices('Surveyor');

  useEffect(() => {
    if (!show) return;
    setFormData({
      estimatedTurnAroundTime: initialValues.estimatedTurnAroundTime ?? '',
      etaReason: initialValues.etaReason ?? '',
      assignedSurveyor: initialValues.assignedSurveyor ?? '',
      hardCost: initialValues.hardCost,
      processingFee: initialValues.processingFee ?? ''
    });
  }, [show, initialValues]);

  const handleSubmit = () => {
    onSubmit({
      estimatedTurnAroundTime: formData.estimatedTurnAroundTime,
      etaReason: formData.etaReason,
      ...(showSurveyOrderFields
        ? {
            assignedSurveyor: formData.assignedSurveyor,
            hardCost: formData.hardCost,
            processingFee: formData.processingFee
          }
        : {})
    });
  };

  const handleCancel = () => {
    setFormData({
      estimatedTurnAroundTime: '',
      etaReason: '',
      assignedSurveyor: '',
      hardCost: '',
      processingFee: ''
    });
    onHide();
  };

  const isFormValid = formData.estimatedTurnAroundTime;

  return (
    <Modal show={show} onHide={handleCancel} centered backdrop="static" style={{ zIndex: '99999' }}>
      <Modal.Header>
        <Modal.Title>
          <h6 className="mb-0">ETA Required</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-auto">
        <Form.Group className="mb-3">
          <Form.Label>Estimated Turnaround Time</Form.Label>
          <Form.Control
            type="date"
            value={formData.estimatedTurnAroundTime}
            onChange={e => setFormData({ ...formData, estimatedTurnAroundTime: e.target.value })}
            disabled={showProgress}
            required
          />
        </Form.Group>

        {showSurveyOrderFields && (
          <>
            <Form.Group>
              <Form.Label>Assigned Surveyor</Form.Label>
              <Form.Control
                as="select"
                value={formData.assignedSurveyor}
                onChange={e => setFormData({ ...formData, assignedSurveyor: e.target.value })}
                disabled={showProgress}
              >
                <option value=""></option>
                {surveyors.map((surveyor, index) => (
                  <option key={index} value={surveyor}>
                    {surveyor}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Hard Cost</Form.Label>
              <Form.Control
                type="number"
                value={formData.hardCost}
                onChange={e => setFormData({ ...formData, hardCost: e.target.value })}
                disabled={showProgress}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Processing Fee</Form.Label>
              <Form.Control
                type="number"
                value={formData.processingFee}
                onChange={e => setFormData({ ...formData, processingFee: e.target.value })}
                disabled={showProgress}
              />
            </Form.Group>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button size="sm" disabled={showProgress} className="ml-2 px-2" variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          size="sm"
          disabled={showProgress || !isFormValid}
          className="ml-2 px-2 d-inline-flex align-items-center justify-content-center"
          variant="primary"
          onClick={handleSubmit}
        >
          {showProgress && <Spinner size="sm" animation="border" className="mr-1" />}
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ETARequiredModal;
